/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FindPrebidsResponseDto } from '../../models/find-prebids-response-dto';

export interface FindPrebids$Params {
  auc_state?: string;

/**
 * Comma separated list of auction ids.
 */
  auc_id?: string;
  cat_id?: string;
  part_id?: string;
  lot_number?: string;
  bidder_number?: number;
  prebid_state?: string;
  bidder_name?: string;
  source?: string;
  user_greylist?: string;

/**
 * Comma separated list of internal states. Unset, the internal state does not restrict the list at all; set, only the named states are returned.
 */
  internal_state?: string;
  '$sortby': string;
  '$sortdir': string;
  '$page': number;
  '$maxpagesize': number;
  'X-API-Version'?: string;
}

export function findPrebids(http: HttpClient, rootUrl: string, params: FindPrebids$Params, context?: HttpContext): Observable<StrictHttpResponse<FindPrebidsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, findPrebids.PATH, 'get');
  if (params) {
    rb.query('auc_state', params.auc_state, {});
    rb.query('auc_id', params.auc_id, {});
    rb.query('cat_id', params.cat_id, {});
    rb.query('part_id', params.part_id, {});
    rb.query('lot_number', params.lot_number, {});
    rb.query('bidder_number', params.bidder_number, {});
    rb.query('prebid_state', params.prebid_state, {});
    rb.query('bidder_name', params.bidder_name, {});
    rb.query('source', params.source, {});
    rb.query('user_greylist', params.user_greylist, {});
    rb.query('internal_state', params.internal_state, {});
    rb.query('$sortby', params['$sortby'], {});
    rb.query('$sortdir', params['$sortdir'], {});
    rb.query('$page', params['$page'], {});
    rb.query('$maxpagesize', params['$maxpagesize'], {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FindPrebidsResponseDto>;
    })
  );
}

findPrebids.PATH = '/api/prebids';
